module.exports = __webpack_public_path__ + "img/bornutti_lookbook.443cac66.jpg";